export default "/static/build/swiss-army-knife.png";